
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3 12.59l2.977-2.986a2 2 0 012.828-.001l2.809 2.812 1.455-1.459a2 2 0 012.829 0L17 12.075v2.804l-2.516-2.51-1.456 1.459a2 2 0 01-2.83 0l-2.806-2.811L3 15.397V12.59z"}}),_c('circle',{attrs:{"cx":"12.5","cy":"6.5","r":"1.5"}}),_c('path',{attrs:{"d":"M4 2a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V4a2 2 0 00-2-2H4zm0-2h12a4 4 0 014 4v12a4 4 0 01-4 4H4a4 4 0 01-4-4V4a4 4 0 014-4z"}})])
          )
        }
      }
    